import { render, staticRenderFns } from "./footer-nav.vue?vue&type=template&id=071bcf33&scoped=true&"
import script from "./footer-nav.vue?vue&type=script&lang=js&"
export * from "./footer-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071bcf33",
  null
  
)

export default component.exports